import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('section')`
  position: relative;
`;

export const TableHead = styled('thead')`
  white-space: nowrap;
  th {
    position: sticky;
    background: ${({ theme }) => theme.color.charcoal} !important;
    > svg {
      cursor: help;
      display: inline-block;
      margin-bottom: -8px;
      margin-top: -8px;
      margin-right: -8px;
      > * {
        fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
      }
    }
  }
`;

export const NameColumnHeader = styled('th')<{
  isSticky: boolean;
}>`
  width: 116px;
  ${media.mdDown`
    left: -1px;
    z-index: 1;
    border-right: ${({ isSticky, theme }) =>
      isSticky ? `1px solid ${theme.color.whiteRGBA(0.1)} !important` : 'none'};
    ${({ isSticky }) => isSticky && `width: 95px;`}
	`};
`;

export const SnowflakeColumnHeader = styled('th')`
  width: 56px;
`;

export const SnowflakeColumn = styled('td')``;

export const WatchlistColumn = styled('td')`
  width: 50px;
  && {
    padding-right: 10px;
  }
`;

export const PELabel = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  && {
    width: auto;
    display: inline-block;
  }
  margin-right: 4px;
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.whiteRGBA(0.2)};
  cursor: help;
  display: inline-block;
  user-select: none;
`;

export const CompanyName = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  white-space: nowrap;
  cursor: help;
  display: inline-block;
  user-select: none;
  border-bottom: 1px dotted ${({ theme }) => theme.color.whiteRGBA(0.2)};
  && {
    width: auto;
    max-width: 100%;
    padding-right: 0;
  }
`;

export const ToolTipText = styled('span')`
  display: inline-block;
  max-width: 200px;
`;

export const ScrollPane = styled('div')`
  overflow-x: auto;
  > table {
    min-width: 920px;
  }
`;

export const ValueColumn = styled('td')<{
  value: null | number;
}>`
  color: ${({ value, theme }) =>
    theme.color.whiteRGBA(value === null ? 0.3 : 1)};
`;

export const SnowflakeBone = styled('span')`
  background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-left: ${({ theme }) => theme.x1_5}px;
`;

export const NoResults = styled('td')`
  text-align: center !important;
  padding: ${({ theme }) => theme.x5spacePx}px 0 !important;
  border-bottom: none !important;
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.textSoft};
`;

export const ValuationRatioWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 255px;
  > span {
    padding: 0 ${({ theme }) => theme.x1spacePx}px;
    padding-top: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const ValuationItemLabel = styled('div')`
  ${({ theme }) => theme.typography.xSmallStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  > strong {
    ${({ theme }) => theme.typography.xLargeStrong}
  }
  > span {
    opacity: 0.3;
    padding-left: 4px;
  }
`;

export const ValuationItemText = styled('div')`
  ${({ theme }) => theme.typography.tiny}
  opacity: 0.5;
`;

export const ValuationItemWrapper = styled('div')`
  padding: ${({ theme }) => theme.x1spacePx}px;
`;
